import { apiClient } from '@/api/client';
import type { SpringPage } from '@/types/students';
import type {
  AssignmentDetail,
  AssignmentListItem,
  AssignmentListParams,
  AssignmentSubmissionItem,
  SubmissionListParams,
} from '@/types/assignments';

function buildListQuery(params: AssignmentListParams): URLSearchParams {
  const q = new URLSearchParams();
  if (params.communityId !== undefined && params.communityId !== null) {
    q.set('communityId', String(params.communityId));
  }
  if (params.page !== undefined) q.set('page', String(params.page));
  if (params.size !== undefined) q.set('size', String(params.size));
  if (params.sort) q.set('sort', params.sort);
  if (params.search) q.set('search', params.search);
  if (params.type) q.set('type', params.type);
  if (params.published !== undefined && params.published !== null) {
    q.set('published', String(params.published));
  }
  if (params.courseId !== undefined && params.courseId !== null) {
    q.set('courseId', String(params.courseId));
  }
  return q;
}

function buildSubmissionQuery(params: SubmissionListParams): URLSearchParams {
  const q = new URLSearchParams();
  if (params.status) q.set('status', params.status);
  if (params.page !== undefined) q.set('page', String(params.page));
  if (params.size !== undefined) q.set('size', String(params.size));
  if (params.sort) q.set('sort', params.sort);
  return q;
}

export async function listAssignments(
  params: AssignmentListParams,
): Promise<SpringPage<AssignmentListItem>> {
  const { data } = await apiClient.get<SpringPage<AssignmentListItem>>(
    `/admin/assignments`,
    { params: buildListQuery(params) },
  );
  return data;
}

export async function getAssignment(assignmentId: number): Promise<AssignmentDetail> {
  const { data } = await apiClient.get<AssignmentDetail>(
    `/admin/assignments/${assignmentId}`,
  );
  return data;
}

export async function listSubmissions(
  assignmentId: number,
  params: SubmissionListParams,
): Promise<SpringPage<AssignmentSubmissionItem>> {
  const { data } = await apiClient.get<SpringPage<AssignmentSubmissionItem>>(
    `/admin/assignments/${assignmentId}/submissions`,
    { params: buildSubmissionQuery(params) },
  );
  return data;
}
